import BuildBrand from "./BuildBrand";

const BuildTopbar = () => {
  return (
    <header className="apl-topbar">
      <div className="apl-shell apl-nav">
        <BuildBrand ariaLabel="Utiva AI Product Lab home" />
        <nav className="apl-nav-links" aria-label="Primary navigation">
          <a href="#lab">The Lab</a>
          <a href="#build">What We Build</a>
          <a href="#method">Lab Method</a>
          <a className="apl-nav-cta" href="#apply">
            Submit a Challenge
          </a>
        </nav>
      </div>
    </header>
  );
};

export default BuildTopbar;
